













































import Vue from 'vue';
import { AccountBeneficiaryResponseModel } from '@/@types/member';
import { CONTINGENT_BENEFICIARY } from '@/constants';
export default Vue.extend({
  name: 'BeneficiaryListing',
  props: {
    beneficiaries: {
      type: Array as () => AccountBeneficiaryResponseModel[],
      required: true,
    },
    reviewMode: {
      type: Boolean,
      default: false,
    },
    hasPrimaryBeneficiaries: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    secondaryBeneficiary(): string {
      return CONTINGENT_BENEFICIARY;
    },
  },
});
